import { useEffect } from 'react';
import { getStore, SecurityActions } from 'simplifyworks-core-ui';
import { getCurrentUser, fetchAuthSession } from 'aws-amplify/auth';
import { detect } from 'detect-browser';
import axios from 'axios';

const browser = detect();

export const useCognitoLogin = () => {
	useEffect(() => {
		const pathname = typeof window !== 'undefined' ? window.location.pathname : '';

		if (!pathname.includes('/publics/cognito/callback')) {
			return;
		}

		async function logInUsingSso(token) {
			const response = await axios.get(
				`${globalParams.hostName}${globalParams.contextName}/auth/log-in/single-sign-on`,
				{
					params: {
						browser: browser?.name,
						browserVersion: browser?.version,
						verso_lang: 'en'
					},
					headers: {
						Authorization: 'Bearer ' + token
					}
				}
			);

			getStore().dispatch(
				SecurityActions.loadUserInfo(
					response.data.token,
					(error) => console.error('loadUserInfo error:', error)
				)
			);
		}

		async function storeAccessToken() {
			try {
				await getCurrentUser();
				const { tokens } = await fetchAuthSession();
				const token = tokens?.idToken?.toString();

				if (!token) {
					throw new Error('No idToken in session');
				}

				await logInUsingSso(token);
				console.info('SSO login via Cognito → Sify OK');
			} catch (err) {
				console.error('User not authenticated in Cognito: ', err);
			}
		}

		storeAccessToken();
	}, []);
};
